// Private, local-only data: ratings, aromas, personal notes + browser tokens.
// Per event so multiple events on the same device don't collide.

const key = (eventId, name) => `0gb:${eventId}:${name}`;

function read(k, fallback) {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : fallback;
  } catch { return fallback; }
}
function write(k, v) {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ }
}

export const store = {
  // anonymous browser token (also used for one-attempt / one-vote protection)
  getToken(eventId) {
    const k = key(eventId, 'token');
    let t = read(k, null);
    if (!t) { t = cryptoRandom(); write(k, t); }
    return t;
  },
  // language
  getLang() { return read('0gb:lang', null); },
  setLang(l) { write('0gb:lang', l); },
  // private tasting data keyed by productId
  getTasting(eventId) { return read(key(eventId, 'tasting'), {}); },
  setTasting(eventId, data) { write(key(eventId, 'tasting'), data); },
  updateProduct(eventId, productId, patch) {
    const all = this.getTasting(eventId);
    all[productId] = { ...(all[productId] || {}), ...patch };
    this.setTasting(eventId, all);
    return all;
  },
  // local favourite (mirrors the shared vote)
  getFavourite(eventId) { return read(key(eventId, 'favourite'), null); },
  setFavourite(eventId, productId) { write(key(eventId, 'favourite'), productId); },
  // saved contact details (reused between quiz and order)
  getContact() { return read('0gb:contact', {}); },
  setContact(c) { write('0gb:contact', { ...this.getContact(), ...c }); },
};

function cryptoRandom() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'tok-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}
